import { FloatButton, Modal, Form, Select, Input, Button } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { useState } from "react";
import apiAction from "../../ajax/service";

const { TextArea } = Input;

function Float() {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {

    await apiAction("workspace",{...values , workspaceId:sessionStorage.getItem('selectedWorkspace')},"add_incident")
    // TODO: send to backend API
    // await fetch("/api/support", { method: "POST", body: JSON.stringify(values) })
    form.resetFields();
    setOpen(false);
  };

  return (
    <>
      <FloatButton
        shape="square"
        icon={<MessageOutlined style={{ fontSize: 14 }} />}
        description={<span style={{ fontSize: 12 }}>Support</span>}
        style={{
          right: 20,
          bottom: 20,
          height: 48,
          minWidth: 100
        }}
        onClick={() => setOpen(true)}
      />

      <Modal
        title="Support & Feedback"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        style={{ top: "20%" }}
        zIndex={9999}
      >
       <p style={{ marginBottom: 16 }}>
  Have an issue? Want to appreciate something? Need enterprise support?
  Tell us what's on your mind.
</p>
<p style={{
  marginBottom: 16,
  backgroundColor: '#fffbe6',
  border: '1px solid #ffe58f',
  borderRadius: 6,
  padding: '10px 14px',
  fontSize: 13,
  color: '#614700',
}}>
  If you face any issues submitting this, write to us at{' '}
  <a href="mailto:care@scaleflow.in" style={{ color: '#1677ff', fontWeight: 600 }}>
    care@scaleflow.in
  </a>{' '}
  or{' '}
  <a href="mailto:scaleupbusiness2025@gmail.com" style={{ color: '#1677ff', fontWeight: 600 }}>
    scaleupbusiness2025@gmail.com
  </a>
</p>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            label="Category"
            name="category"
            rules={[{ required: true, message: "Please select a category" }]}
          >
            <Select
              placeholder="Select a category"
              options={[
                { label: "Report an Issue", value: "issue" },
                { label: "Applause / Appreciation", value: "applause" },
                { label: "Custom License Request", value: "license" },
                { label: "Update License Request", value: "licenseUpdate" },
                { label: "Schedule a Product Call", value: "call" },
                { label: "Feature Request", value: "feature" }
              ]}
            />
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
            rules={[
              { required: true, message: "Please describe your request" }
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Be specific. The more context you give, the faster we can help."
            />
          </Form.Item>

          <Form.Item>
            <Button  type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default Float;
